// @ts-nocheck
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { RocketChatService } from '../services/rocketChat.service';
import { LastLoginDetailsService } from '../services/last-login-details.service';
import * as CryptoJS from 'crypto-js';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyMasterService } from '../services/companymaster.service';
import { rocketChatRemove } from '../enums/rocketChatRemove';
import { safeJsonStringify } from '../shared/utils';
import { GoogleLoginProvider, SocialAuthService } from 'angularx-social-login';
import { OTPLoginService } from '../services/otp-login.service';
import { NotificationComponent } from '../otp-login/notification/notification.component';
import { environment } from '../../environments/environment'

declare var $: any;
declare var jQuery: any;
declare var swal: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {
  loginConfig: any = {};
  companyList: any = [];
  selectedCompanyId: any;
  public environmentSettings: any;
  chatEngineURL: any;
  eva: any;
  returnUrl: any;
  listOfCompanyDetails: any;
  loginModel: any;
  userName: string;
  isADCompany: boolean = false;
  LoginDisabled: boolean = false;
  isCompanyListDisable: boolean = true;
  isEmailForCompany: string = 'Please enter a valid email id or username';
  companyConfig: any;
  isEmailValid: boolean = false;
  showCompanySelectionStep: boolean = false;
  companyFetchInProgress: boolean = false;
  @ViewChild('userInput') userInput: ElementRef<HTMLInputElement>;
  @ViewChild('passwordInput') passwordInput: ElementRef<HTMLInputElement>;
  private messagePopUpTimeout: any = null; // Store timeout reference
  loginForm = new FormGroup({
    companyName: new FormControl('', [Validators.required]),
    userName: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

    passwordVisible: boolean = false;  // Flag to track visibility of the password
  constructor(
    public activeModal: NgbActiveModal,
    public otpLoginService: OTPLoginService,
    private router: Router,
    private companyService: CompanyMasterService,
    private loginService: LoginService,
    private rocketChatService: RocketChatService,
    private route: ActivatedRoute,
    private lastloginService: LastLoginDetailsService,
    private socialAuthService: SocialAuthService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    // Disabled to prevent CSP report errors - angularx-social-login handles Google Sign-In internally
    // this.initGoogleAuth();
    $('body').removeClass('dashboard-page');
    // Prevent body scrolling on login page
    $('body, html').addClass('login-page-active');
    $('body, html').css({
      'overflow': 'hidden',
      'height': '100vh',
      'max-height': '100vh',
      'position': 'fixed',
      'width': '100%'
    });

    this.environmentSettings = environment;
    
    var sessionValue = sessionStorage.getItem('SessionName');
    if (sessionValue != 'userLoggedIn') {
      this.loginService.logOut();
    }

    const self = this;
    setTimeout(function () {
      self.activeModal.dismiss('dismiss');
      self.userInput.nativeElement.focus(); 
    }, 100);

    // Keep login fields empty on refresh even if browser attempts autofill.
    this.forceClearPrefilledCredentials();

    var token = localStorage.getItem('token');

    //added on 4Apr

    if (_.size(this.route.snapshot.queryParams['emailId'])) {
      this.userName = this.route.snapshot.queryParams['emailId'];
      this.loginForm.controls.userName.updateValueAndValidity();
      this.companyFetchInProgress = true;
      this.getCompaniesByEmailId();
    }

    var returnURL = this.returnUrl;
    var splitQueryParameters = '';
    if (returnURL != undefined) {
      splitQueryParameters = returnURL.split('?');
    }
    this.redirectPath = decodeURIComponent(`${window.location.hash.split('returnUrl=')[1]}`)

    if (_.isNil(token)) {
      this.getCompanies();
      this.hideTopBar();
    }
    //following condition occures when user login through pss and jumps to goveva menus
    else if (splitQueryParameters.length === 2) {
      var queryParameters = splitQueryParameters[1];
      var parameters = queryParameters.split('&');
      if (parameters.length === 2) {
        var IsgoEvaUser = parameters[0].split('=');
        var goEvaUserEmail = parameters[1].split('=');
        if (IsgoEvaUser[1]) {
          var loginWithoutPassword = {
            UserName: goEvaUserEmail[1],
          };
          //login from PSS and click on the goveva menu then [login into Goveva system without password and redirect to request page [This request coming from PSS]
          this.loginService
            .loginWithoutPassword(loginWithoutPassword)
            .subscribe((data) => {
              // @ts-ignore
              if (data.status == 0) {
                // @ts-ignore
                localStorage.setItem('user', safeJsonStringify(data.user));
                // @ts-ignore
                localStorage.setItem('token', data.token);
                // @ts-ignore
                localStorage.setItem(
                  'resources',
                  safeJsonStringify(data.resources)
                );
                this.router.navigate([
                  'structure',
                  {
                    outlets: { 'structure-outlet': [splitQueryParameters[0]] },
                  },
                ]);
              }
            });
        }
      }
    } else if (splitQueryParameters.length === 3) {
      let pssLink = splitQueryParameters.length - 1;
      window.open(pssLink.toString());
    } else {
      //if already login
      this.router.navigate([
        'structure',
        { outlets: { 'structure-outlet': 'dashboards/director-view' } },
      ]);
    }
  }

  forceClearPrefilledCredentials() {
    const clearValues = () => {
      this.userName = '';
      this.loginForm.controls['userName'].setValue('', { emitEvent: false });
      this.loginForm.controls['password'].setValue('', { emitEvent: false });
      this.loginForm.controls['companyName'].setValue('', { emitEvent: false });
      this.selectedCompanyId = null;
      this.companyList = [];
      this.listOfCompanyDetails = [];
      this.showCompanySelectionStep = false;
      this.companyFetchInProgress = false;

      if (this.userInput && this.userInput.nativeElement) {
        this.userInput.nativeElement.value = '';
      }
      if (this.passwordInput && this.passwordInput.nativeElement) {
        this.passwordInput.nativeElement.value = '';
      }
    };

    clearValues();
    // Some browsers inject autofill after initial paint; clear once again.
    setTimeout(clearValues, 200);
  }
initGoogleAuth() {
  // Check if gapi is available
  if (typeof gapi === 'undefined' || !gapi) {
    // Google API not loaded - Google Sign-In will not be available
    return;
  }

  try {
    gapi.load('auth2', () => {
      try {
        gapi.auth2.init({
          client_id: '1074340764884-nrtd2uj2umievmpnvml2kkdcbb2m5hp7.apps.googleusercontent.com',
          scope: 'email profile'
        }).then(() => {
          // Google auth2 initialized successfully
        }).catch((err: any) => {
          // Suppress CSP report errors (400 Bad Request from accounts.google.com)
          // These are non-critical and happen when origin isn't registered in Google Cloud Console
          if (err && (
            err.error === 'idpiframe_initialization_failed' ||
            (err.message && err.message.includes('cspreport')) ||
            (err.message && err.message.includes('IdpIFrameHttp'))
          )) {
            // Silently handle CSP/configuration errors - don't break the app
            return;
          }
          // Log other errors for debugging
          if (err && err.error !== 'idpiframe_initialization_failed') {
            // Only log non-CSP related errors
          }
        });
      } catch (error: any) {
        // Suppress CSP-related errors
        if (error && error.message && (
          error.message.includes('cspreport') ||
          error.message.includes('IdpIFrameHttp') ||
          error.message.includes('accounts.google.com')
        )) {
          // Silently ignore CSP report errors
          return;
        }
        // Don't break the app if Google Auth fails to initialize
      }
    });
  } catch (error: any) {
    // Suppress CSP-related errors
    if (error && error.message && (
      error.message.includes('cspreport') ||
      error.message.includes('IdpIFrameHttp') ||
      error.message.includes('accounts.google.com')
    )) {
      // Silently ignore CSP report errors
      return;
    }
    // Don't break the app if Google Auth fails to load
  }
}


  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  getInputValueChange(event: Event): string {
    // @ts-ignore
    return (event.target ? (event.target as HTMLInputElement) : event).value;
  }

  clearUserSession() {
    let loginData: any;
    loginData = {
      EmailId: this.userName, // Company Email,
      CompanyId: this.selectedCompanyId, // Company Id
    };

    this.loginService.clearSession(loginData).subscribe((response) => {
      console.log('clearSession response', response);
    });
  }

  secretKey = 'Secret message';

  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
  }

  decrypt(textToDecrypt: string) {
    return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(
      CryptoJS.enc.Utf8
    );
  }

  blinkCur() {
    var inputValue = this.loginForm.controls.password.value;
    var numChars = inputValue.length;
    var showText = '';
    var i;

    for (i = 0; i < numChars; i++) {
      showText += '&#8226;';
    }

    $('.fake-input').html(
      '<span class="blinking-cursor">' + showText + '|</span>'
    );
  }
  blinkCurOut() {
    $('.fake-input span').text('');

    var inputValue = this.loginForm.controls.password.value;
    var numChars = inputValue.length;
    var showText = '';
    var i;

    if (inputValue.length > 0) {
      for (i = 0; i < numChars; i++) {
        showText += '&#8226;';
      }

      $('.fake-input').html(showText);
    } else {
      $('.fake-input').html('Password');
    }
  }
  RemoveSavePassword() {
    var inputValue = this.loginForm.controls.password.value;
    var numChars = inputValue.length;
    var showText = '';
    var i;

    for (i = 0; i < numChars; i++) {
      showText += '&#8226;';
    }

    $('.fake-input').html(showText);
  }

  getCompanies() {
    this.loginService.companyListForUserManagement().subscribe((companies) => {
      if (companies.status != 0) {
        this.router.navigate(['companySetup']);
      }
    });
  }

  clearToken(loginModel) {
    loginModel = { encryptedToken: this.encrypt(JSON.stringify(loginModel))};
    this.loginService
      .clearTokenByUserAgent(loginModel)
      .subscribe((tokenResult) => {
        if (tokenResult.status == 0) {
          console.log('user token cleared');
        }
      });
  }

  onEmailChange() {
    // Reset everything when email changes
    this.isEmailValid = false;
    this.showCompanySelectionStep = false;
    this.companyFetchInProgress = false;
    this.companyList = [];
    this.listOfCompanyDetails = [];
    this.selectedCompanyId = null;
    this.loginForm.controls['companyName'].setValue('');
    this.loginForm.controls['password'].setValue('');
    this.isCompanyListDisable = true;
    this.isEmailForCompany = 'Please enter a valid email id or username';
  }

  canProceedToCompanySelection(): boolean {
    const userNameControl = this.loginForm.controls['userName'];
    const passwordControl = this.loginForm.controls['password'];
    return (
      userNameControl.valid &&
      !userNameControl.hasError('email') &&
      passwordControl.valid
    );
  }

  canLoginWithSelectedCompany(): boolean {
    return (
      !!this.selectedCompanyId &&
      this.loginForm.controls['password'].valid &&
      this.loginForm.controls['userName'].valid
    );
  }

  getSelectedCompanyName(): string {
    const selectedCompany = _.find(this.companyList, { value: this.selectedCompanyId });
    return selectedCompany ? selectedCompany.label : '';
  }

  continueToCompanySelection() {
    this.loginForm.controls['userName'].markAsTouched();
    this.loginForm.controls['password'].markAsTouched();

    const enteredUserName = _.trim(this.loginForm.controls['userName'].value);
    this.userName = enteredUserName;
    this.selectedCompanyId = null;
    this.loginForm.controls['companyName'].setValue('');
    this.companyList = [];

    if (!this.canProceedToCompanySelection()) {
      this.showCompanySelectionStep = false;
      return;
    }

    this.showCompanySelectionStep = false;
    this.companyFetchInProgress = true;
    this.getCompaniesByEmailId();
  }

  backToCredentialsStep() {
    this.showCompanySelectionStep = false;
    this.companyFetchInProgress = false;
    this.loginForm.controls['companyName'].setValue('', { emitEvent: false });
    this.selectedCompanyId = null;
  }

  checkEmailValidity() {
    // Check if email is valid
    const emailControl = this.loginForm.controls['userName'];
    if (emailControl.touched && emailControl.valid && !emailControl.hasError('email')) {
      // Email format is valid, but wait for companies to be loaded
      return true;
    } else {
      this.isEmailValid = false;
      return false;
    }
  }

  isEmailFormatValid(email: string): boolean {
    // Simple email format validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  getCompaniesByEmailId() {
    //get array of company Id using email id
    this.listOfCompanyDetails = [];
    this.companyList = [];
    let emailId = this.userName;
    var CopyEmailAddress = '';
    
    // Reset email valid flag initially
    this.isEmailValid = false;
    
    // Check email validity when focusout
    const isEmailFormatValid = this.checkEmailValidity();
    const isEmailFormatValidRegex = this.isEmailFormatValid(emailId);

    if (emailId != '') {
      try {
        this.isEmailForCompany =
          'Either due to low bandwidth or API unavailable';
        return this.loginService
          .getCompanyIdsByEmailId(emailId)
          .subscribe(
            (companyIds) => {
              if (companyIds.status == 0) {
                if (companyIds.companyIds.length > 0) {
                  localStorage.setItem('CopyEmailAddress', emailId);
                  CopyEmailAddress = localStorage.getItem('CopyEmailAddress');
                  this.loginService
                    .getCompanyListByIds(companyIds)
                    .subscribe(
                      (companies) => {
                        // @ts-ignore
                        if (companies.status == 0) {
                          // @ts-ignore
                          this.listOfCompanyDetails = companies.companyList || [];
                          // @ts-ignore
                          this.companyList = (companies.companyList || []).map(company =>{
                            return {
                              label: company.CompanyName,
                              value: company._id,
                            };
                          });
                          
                          // Check if company list is empty after successful API call
                          if (this.companyList.length === 0) {
                            this.isCompanyListDisable = true;
                            this.isEmailValid = false;
                            this.showCompanySelectionStep = false;
                            // Show alert when no companies found even though API succeeded
                            if (emailId && emailId.trim() !== '') {
                              this.showCompanyNotFoundAlert();
                            }
                          } else {
                            this.isCompanyListDisable = false;
                            // Email is valid and companies found - enable password field
                            if (isEmailFormatValid && this.companyList.length > 0) {
                              this.isEmailValid = true;
                            }
                            if (this.companyList.length === 1) {
                              this.selectedCompanyId = this.companyList[0].value;
                              this.loginForm.controls['companyName'].setValue(this.selectedCompanyId);
                              this.companySelection(this.selectedCompanyId);
                              this.showCompanySelectionStep = false;
                            } else {
                              this.showCompanySelectionStep = true;
                            }
                          }
                          this.companyFetchInProgress = false;
                          //console.log(this.companyList)
                        } else {
                          this.companyList = [];
                          this.isEmailValid = false;
                          this.showCompanySelectionStep = false;
                          this.companyFetchInProgress = false;
                          // Show alert when companies couldn't be fetched
                          if (emailId && emailId.trim() !== '') {
                            this.showCompanyNotFoundAlert();
                          }
                        }
                      },
                      (error) => {
                        console.log('error getting company list', error);
                        this.companyList = [];
                        this.isEmailValid = false;
                        this.companyFetchInProgress = false;
                        // Show alert when API call fails, especially for 503 Service Unavailable
                        if (emailId && emailId.trim() !== '') {
                          // Check if error is 503 Service Unavailable
                          if (error && error.status === 503) {
                            console.log('503 Service Unavailable detected');
                            this.showCompanyNotFoundAlert();
                          } else {
                            // Show alert for other errors too
                            this.showCompanyNotFoundAlert();
                          }
                        }
                      }
                    );
                } else {
                  this.isCompanyListDisable = true;
                  this.isEmailForCompany =
                    'Either due to low bandwidth or API unavailable';
                  this.isEmailValid = false;
                  this.showCompanySelectionStep = false;
                  this.companyFetchInProgress = false;
                  // Show alert when no companies found
                  if (emailId && emailId.trim() !== '') {
                    this.showCompanyNotFoundAlert();
                  }
                }
              } else {
                this.isEmailForCompany = 'Please enter valid email id';
                localStorage.removeItem('CopyEmailAddress');
                this.isEmailValid = false;
                this.showCompanySelectionStep = false;
                this.companyFetchInProgress = false;
                // Don't show IT admin alert for invalid email
              }
            },
            (error) => {
              console.log('error getting company ids', error);
              this.isEmailForCompany =
                'Either due to low bandwidth or API unavailable';
              this.companyList = [];
              this.isEmailValid = false;
              this.showCompanySelectionStep = false;
              this.companyFetchInProgress = false;
              // Show alert when API call fails, especially for 503 Service Unavailable
              if (emailId && emailId.trim() !== '') {
                // Check if error is 503 Service Unavailable
                if (error && error.status === 503) {
                  console.log('503 Service Unavailable detected');
                  this.showCompanyNotFoundAlert();
                } else {
                  // Show alert for other errors too
                  this.showCompanyNotFoundAlert();
                }
              }
            }
          );
      } catch (error) {
        console.log('error occured', error);
        this.isEmailForCompany =
          'Either due to low bandwidth or API unavailable';
        this.companyList = [];
        this.isEmailValid = false;
        this.showCompanySelectionStep = false;
        this.companyFetchInProgress = false;
        // Show alert when exception occurs
        if (emailId && emailId.trim() !== '') {
          this.showCompanyNotFoundAlert();
        }
      }
    }

    if (emailId == 'superadmin@gmail.com' || emailId == '') {
      this.companyConfig = {
        authLogin: 'Inactive',
        twoFactor: 'Inactive',
        normalLogin: true,
      };
    }
  }

  closeModal() {
    console.log('closeModal called');
    const messagePopUp = $('#messagePopUp');
    if (messagePopUp.length) {
      // Hide the modal
      try {
        messagePopUp.modal('hide');
      } catch (e) {
        console.log('Error hiding modal:', e);
      }
      
      // Force immediate cleanup to prevent screen freeze
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      $('body').css('padding-right', '');
      $('body').css('overflow', '');
      messagePopUp.removeClass('show');
      messagePopUp.css('display', 'none');
      messagePopUp.css('padding-right', '');
      messagePopUp.attr('aria-hidden', 'true');
      
      // Additional cleanup after a short delay
      setTimeout(() => {
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        $('body').css('padding-right', '');
        $('body').css('overflow', '');
      }, 50);
    }
  }

  showModalWithBackdrop(messagePopUp: any, closeBtn: any) {
    // Use 'show' method with backdrop enabled for click dismissal
    // backdrop: true allows clicking outside the modal to close it
    messagePopUp.modal({
      backdrop: true,  // Enable backdrop - clicking outside will close
      keyboard: true,  // Enable Escape key to close
      show: true
    });
    
    // Set up close button handler after modal is shown
    messagePopUp.one('shown.bs.modal', () => {
      this.setupModalCloseButton();
      console.log('Modal shown successfully - click outside to close');
    });
    
    // Also set up immediately as backup
    this.setupModalCloseButton();
  }

  setupModalCloseButton() {
    // Set up close button handler for all popups (backup for JavaScript-based calls)
    const closeBtn = $('#modalCloseBtn');
    const messagePopUp = $('#messagePopUp');
    
    if (closeBtn.length && messagePopUp.length) {
      // Remove any existing handlers to avoid duplicates
      closeBtn.off('click.modalClose');
      closeBtn.find('span').off('click.modalClose');
      
      // Set up close button click handler as backup
      const closeHandler = (e: any) => {
        e.stopPropagation();
        this.closeModal();
      };
      
      // Attach handler to both button and span
      closeBtn.on('click.modalClose', closeHandler);
      closeBtn.find('span').on('click.modalClose', closeHandler);
    }
  }

  showCompanyNotFoundAlert() {
    console.log('showCompanyNotFoundAlert called');
    // Show immediately without delay
    const alertTitle = $('#alertTitle');
    const alertTitleText = $('#alertTitleText');
    const alertMessage = $('#alertMessage');
    const messagePopUp = $('#messagePopUp');
    const closeBtn = $('#modalCloseBtn');
    
    if (!alertTitle.length || !alertMessage.length || !messagePopUp.length) {
      console.error('Modal elements not found in DOM');
      // Retry once after a tiny delay if elements not found
      setTimeout(() => this.showCompanyNotFoundAlert(), 50);
      return;
    }
    
    // Clear any existing timeout from previous popups to avoid conflicts
    if (this.messagePopUpTimeout) {
      clearTimeout(this.messagePopUpTimeout);
      this.messagePopUpTimeout = null;
    }
    
    // Update title text - style as dark blue banner with white text
    if (alertTitleText.length) {
      alertTitleText.text('Unable to load Company');
      alertTitleText.css({
        'color': '#fff',
        'font-weight': 'bold',
        'text-transform': 'uppercase'
      });
    } else {
      alertTitle.text('Unable to load Company');
      alertTitle.css({
        'color': '#fff',
        'font-weight': 'bold',
        'text-transform': 'uppercase'
      });
    }
    
    // Style the header as dark blue banner
    alertTitle.css({
      'background-color': '#1a237e', // Dark blue
      'color': '#fff',
      'padding': '10px 15px',
      'margin': '0',
      'border-radius': '0',
      'border-bottom': 'none'
    });
    
    // Update message text
    alertMessage.css({
      'color': '#f00',
      'font-size': '14px',
      'padding': '10px 15px',
      'margin': '0'
    });
    alertMessage.text('Something is preventing the login screen from loading fully. Please contact your internal IT team to resolve this.');
    
    // Hide close button for this alert
    if (closeBtn.length) {
      closeBtn.css('display', 'none');
    }
    
    // Remove any existing event listeners
    messagePopUp.off('hidden.bs.modal.clearTimeout');
    messagePopUp.off('hidden.bs.modal.companyNotFound');
    messagePopUp.off('click.bs.modal.backdrop');
    
    // Set up event listener to clean up when modal is closed
    messagePopUp.on('hidden.bs.modal.companyNotFound', () => {
      // Clean up backdrop and body classes when modal is closed
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      $('body').css('padding-right', '');
      // Remove event listeners
      messagePopUp.off('hidden.bs.modal.companyNotFound');
    });
    
    // Ensure backdrop clicks work to close modal
    $(document).off('click.bs.modal.backdrop').on('click.bs.modal.backdrop', '.modal-backdrop', (e: any) => {
      if ($(e.target).is('.modal-backdrop')) {
        this.closeModal();
      }
    });
    
    // Show modal with backdrop enabled for click dismissal
    try {
      // Check if modal is already shown - if so, just update content
      if (messagePopUp.hasClass('show')) {
        console.log('Modal already visible, updating content');
        return;
      }
      
      // Hide any existing modals first to prevent conflicts
      $('.modal.show').not(messagePopUp).modal('hide');
      
      messagePopUp.modal({
        backdrop: true,  // Enable backdrop - clicking outside will close
        keyboard: true,  // Enable Escape key to close
        show: true
      });
      
    } catch (error) {
      console.error('Error showing modal:', error);
      // Fallback: try direct show
      try {
        messagePopUp.modal('show');
        this.setupModalCloseButton();
      } catch (e) {
        console.error('Error with modal show fallback:', e);
      }
    }
  }

  login(loginType = 'normal') {
    if (this.loginForm.status == 'VALID' && loginType == 'normal') {
      localStorage.setItem('isAuthLogin', 'no');
      this.callLogin();
    } else if ('loginByGoogle' == loginType) {
      this.socialAuthService
        .signIn(GoogleLoginProvider.PROVIDER_ID)
        .then((userData) => {
          localStorage.setItem('isAuthLogin', 'yes');
          this.callLogin(userData);
        })
        .catch((error) => {
          console.log(' sign in data : ', error);
        });
    }
  }

callLogin(socialLogin = null) {
  const isGoogleLogin = !!socialLogin;
  const agent = window.navigator.userAgent.toLowerCase();
  const notification_type = agent ? 'Browser' : 'Ipad';

  this.loginModel = {
    UserName: _.toLower(this.loginForm.controls.userName.value),
    CompanyId: this.selectedCompanyId,
    NotificationType: notification_type,
    socialLogin,
  };

  if (!isGoogleLogin) {
    this.loginModel.Password = this.encrypt(this.loginForm.controls.password.value);
  }
  // Clear previous tokens
  this.clearToken(this.loginModel);
if (!environment.MfaLogin || this.loginForm.controls.userName.value==="superadmin@gmail.com"){
  this.loginFunction();
}else{
  this.loginService.login(this.loginModel).subscribe((data) => {
  if(data.status ==0){
  this.router.navigate(['/login-with-otp']); 
  }else{
           this.LoginDisabled = false;
          $('#alertTitle').css('color', '#f00');
          const alertTitleText = $('#alertTitleText');
          if (alertTitleText.length) {
            alertTitleText.text('Failure!');
          } else {
            $('#alertTitle').text('Failure!');
          }
          $('#alertMessage').css('color', '#f00');
          $('#alertMessage').text(data.message);
          // Show modal with backdrop enabled for click dismissal
          $('#messagePopUp').modal({
            backdrop: true,
            keyboard: true,
            show: true
          });
          this.setupModalCloseButton();
          this.messagePopUpTimeoutToogle();
          this.socialAuthService
            .signOut()
            .then((resData) => {
              console.log('resData', resData);
            })
            .catch((error) => {
              console.log('errorerrorerror', error);
            });
          this.router.navigate(['/login']);
  }
});
}
}



   loginFunction() {
    this.LoginDisabled = true;
    this.loginService.login(this.loginModel).subscribe({
      next: (data) => {
      if (data.status == 202) {
        localStorage.removeItem('userToken');
        localStorage.setItem('emailId', this.loginModel.UserName);
        localStorage.setItem('companyId', this.loginModel.CompanyId);
        localStorage.setItem('mobileNumber', data.MobileNumber);
        this.otpLoginService.clearUserCredential();
        this.otpLoginService.setUserCredential(data);
        localStorage.setItem('userToken', data.userToken);
        localStorage.setItem('companyEVA', null);
        this.redirectPath = decodeURIComponent(`${window.location.hash.split('returnUrl=')[1]}`)

        if (this.redirectPath == 'undefined') {
          this.router.navigate(['Submit/LoginOTP']);
        }
        else {
          this.router.navigate(['Submit/LoginOTP'], { queryParams: {returnUrl: this.redirectPath}});                
        }

        const modalRef = this.modalService.open(NotificationComponent);
        modalRef.componentInstance.notify = {
          status: 'Success',
          message: data.message,
        };
      } else {
        const self = this;
        let listOfCompany = _.groupBy(self.listOfCompanyDetails, '_id');
        let companyNameAndValue = this.companyList.find(function (company) {
          return company.value == self.selectedCompanyId;
        });
        let companyData = _.first(listOfCompany[self.selectedCompanyId]);
        this.chatEngineURL = _.get(companyData, 'ChatEngineURL');
        this.eva = _.get(companyData, 'EVA');
        if (data.status == 0) {
          this.LoginDisabled = false;

          if (rocketChatRemove.isRemove.toString() != 'true') {
            let loginChatModel: any;
            loginChatModel = {
              user: data.user.RocketChatUserName,
              password: data.user.RocketChatPassword,
            };

            this.rocketChatService
              .loginToRocketChat(loginChatModel, this.chatEngineURL)
              .then((rocketChatData) => {
                if (rocketChatData.status == 'success') {
                  // Switching to the subsidiary data ----start
                  localStorage.setItem('isSubsidiary', 'false');
                  // Switching to the subsidiary data ----end
                  localStorage.setItem(
                    'companyDetailsGoveva',
                    safeJsonStringify(companyNameAndValue)
                  );
                  localStorage.setItem(
                    'companyDetails',
                    safeJsonStringify({
                      companyName: companyNameAndValue.label,
                      companyID: companyNameAndValue.value,
                    })
                  );
                  localStorage.setItem('user', safeJsonStringify(data.user));
                  localStorage.setItem('companyEVA', this.eva);
                  if (data.user.FirstTimeLogin) {
                    localStorage.setItem(
                      'rocketAuth',
                      rocketChatData.data.authToken
                    );
                    localStorage.setItem(
                      'rocketUserId',
                      rocketChatData.data.userId
                    );
                    localStorage.setItem('rocketBaseURL', this.chatEngineURL);

                    this.router.navigate(['/changePassword']);
                  } else {
                    localStorage.setItem('token', data.token);
                    localStorage.setItem(
                      'resources',
                      safeJsonStringify(data.resources)
                    );

                    localStorage.setItem(
                      'rocketAuth',
                      rocketChatData.data.authToken
                    );
                    localStorage.setItem(
                      'rocketUserId',
                      rocketChatData.data.userId
                    );
                    localStorage.setItem('rocketBaseURL', this.chatEngineURL);

                    this.showTopBar();

                    this.returnUrl =
                      this.route.snapshot.queryParams['returnUrl'] || '/';

                    if (this.returnUrl != '/') {
                      try {
                        var check64 =
                          btoa(atob(this.returnUrl)) == this.returnUrl;
                      } catch (err) {
                        var check64 = false;
                      }
                      if (check64 == true) {
                        this.returnUrl = atob(this.returnUrl);
                      } else {
                        this.returnUrl = this.returnUrl;
                      }
                      if (_.includes(this.returnUrl, 'http')) {
                        window.open(this.returnUrl, '_self');
                      } else {
                        const urlAfterSplit = this.returnUrl.split(':');
                        const lastElement =
                          urlAfterSplit[urlAfterSplit.length - 1];
                        const redirectUrl = _.first(lastElement.split(')'));
                        this.router.navigate([
                          'structure',
                          { outlets: { 'structure-outlet': redirectUrl } },
                        ]);
                      }
                    } else {
                      this.router.navigate([
                        'structure',
                        { outlets: { 'structure-outlet': 'dashboards/director-view' } },
                      ]);
                    }
                  }
                }
              });
          } else {
            // Switching to the subsidiary data ----start
            localStorage.setItem('isSubsidiary', 'false');
            // Switching to the subsidiary data ----end
            localStorage.setItem(
              'companyDetailsGoveva',
              safeJsonStringify(companyNameAndValue)
            );
            localStorage.setItem(
              'companyDetails',
              safeJsonStringify({
                companyName: companyNameAndValue.label,
                companyID: companyNameAndValue.value,
              })
            );
            localStorage.setItem('user', safeJsonStringify(data.user));
            localStorage.setItem('companyEVA', this.eva);
            sessionStorage.setItem('SessionName', 'userLoggedIn');

            if (data.user.FirstTimeLogin) {
              localStorage.setItem('rocketBaseURL', this.chatEngineURL);
              // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
              localStorage.setItem('token', data.token);
              this.router.navigate(['/changePassword']);
            } else {
              localStorage.setItem('token', data.token);
              localStorage.setItem(
                'resources',
                safeJsonStringify(data.resources)
              );

              localStorage.setItem('rocketBaseURL', this.chatEngineURL);

              self.showTopBar();

              self.returnUrl =
                self.route.snapshot.queryParams['returnUrl'] || '/';

              if (self.returnUrl != '/') {
                try {
                  var check64 = btoa(atob(this.returnUrl)) == this.returnUrl;
                } catch (err) {
                  var check64 = false;
                }
                if (check64 == true) {
                  this.returnUrl = atob(this.returnUrl);
                } else {
                  this.returnUrl = this.returnUrl;
                }

                if (
                  _.includes(self.returnUrl, 'http') ||
                  _.includes(self.returnUrl, 'https')
                ) {
                  window.open(self.returnUrl, '_self');
                } else {
                  const urlAfterSplit = self.returnUrl.split(':');
                  const lastElement = urlAfterSplit[urlAfterSplit.length - 1];
                  const redirectUrl = _.first(lastElement.split(')'));

                  this.router.navigate([
                    'structure',
                    { outlets: { 'structure-outlet': redirectUrl } },
                  ]);
                }
              } else {
                self.router.navigate([
                  'structure',
                  { outlets: { 'structure-outlet': 'dashboards/director-view' } },
                ]);
                // .then(() => {
                //   location.reload();
                // });
              }
            }
          }
        } else {
          this.LoginDisabled = false;
          $('#alertTitle').css('color', '#f00');
          const alertTitleText = $('#alertTitleText');
          if (alertTitleText.length) {
            alertTitleText.text('Failure!');
          } else {
            $('#alertTitle').text('Failure!');
          }
          $('#alertMessage').css('color', '#f00');
          $('#alertMessage').text(data.message);
          // Show modal with backdrop enabled for click dismissal
          $('#messagePopUp').modal({
            backdrop: true,
            keyboard: true,
            show: true
          });
          this.setupModalCloseButton();
          this.messagePopUpTimeoutToogle();
          this.socialAuthService
            .signOut()
            .then((resData) => {
              console.log('resData', resData);
            })
            .catch((error) => {
              console.log('errorerrorerror', error);
            });
          self.router.navigate(['/login']);
        }
      }
    },
      error: (error) => {
        console.error('Login request failed', error);
        this.LoginDisabled = false;
        const message =
          error?.error?.message ||
          'Oops something went wrong. Please try again.';
        $('#alertTitle').css('color', '#f00');
        const alertTitleText = $('#alertTitleText');
        if (alertTitleText.length) {
          alertTitleText.text('Failure!');
        } else {
          $('#alertTitle').text('Failure!');
        }
        $('#alertMessage').css('color', '#f00');
        $('#alertMessage').text(message);
        $('#messagePopUp').modal({
          backdrop: true,
          keyboard: true,
          show: true
        });
        this.setupModalCloseButton();
        this.messagePopUpTimeoutToogle();
      }
    });
  }

  loginForADUser() {
    this.loginService.loginForADUser(this.loginModel).subscribe(
      (data) => {
        const self = this;
        let listOfCompany = _.groupBy(self.listOfCompanyDetails, '_id');
        let companyNameAndValue = this.companyList.find(function (company) {
          return company.value == self.selectedCompanyId;
        });
        let companyData = _.first(listOfCompany[self.selectedCompanyId]);
        this.chatEngineURL = _.get(companyData, 'ChatEngineURL');
        this.eva = _.get(companyData, 'EVA');
        if (data.status == 0) {
          if (rocketChatRemove.isRemove.toString() != 'true') {
            let loginChatModel: any;
            loginChatModel = {
              user: data.user.RocketChatUserName, //FirstName + data.user.LastName,
              password: data.user.RocketChatPassword, //this.loginForm.controls.password.value//"Demo@1234"
            };

            this.rocketChatService
              .loginToRocketChat(loginChatModel, this.chatEngineURL)
              .then((rocketChatData) => {
                if (rocketChatData.status == 'success') {
                  // Switching to the subsidiary data ----start
                  localStorage.setItem('isSubsidiary', 'false');
                  // Switching to the subsidiary data ----end
                  localStorage.setItem(
                    'companyDetailsGoveva',
                    safeJsonStringify(companyNameAndValue)
                  );
                  localStorage.setItem(
                    'companyDetails',
                    safeJsonStringify({
                      companyName: companyNameAndValue.label,
                      companyID: companyNameAndValue.value,
                    })
                  );
                  localStorage.setItem('user', safeJsonStringify(data.user));
                  localStorage.setItem('companyEVA', this.eva);
                  localStorage.setItem('token', data.token);
                  localStorage.setItem(
                    'resources',
                    safeJsonStringify(data.resources)
                  );

                  localStorage.setItem(
                    'rocketAuth',
                    rocketChatData.data.authToken
                  );
                  localStorage.setItem(
                    'rocketUserId',
                    rocketChatData.data.userId
                  );
                  localStorage.setItem('rocketBaseURL', this.chatEngineURL);

                  this.showTopBar();

                  this.returnUrl =
                    this.route.snapshot.queryParams['returnUrl'] || '/';
                  if (this.returnUrl != '/') {
                    try {
                      var check64 =
                        btoa(atob(this.returnUrl)) == this.returnUrl;
                    } catch (err) {
                      var check64 = false;
                    }
                    if (check64 == true) {
                      this.returnUrl = atob(this.returnUrl);
                    } else {
                      this.returnUrl = this.returnUrl;
                    }
                    if (_.includes(this.returnUrl, 'http')) {
                      window.open(this.returnUrl, '_self');
                    } else {
                      const urlAfterSplit = this.returnUrl.split(':');
                      const lastElement =
                        urlAfterSplit[urlAfterSplit.length - 1];
                      const redirectUrl = _.first(lastElement.split(')'));
                      this.router.navigate([
                        'structure',
                        { outlets: { 'structure-outlet': redirectUrl } },
                      ]);
                      // .then(() => {
                      //   location.reload();
                      // });
                    }
                  } else {
                    this.router.navigate([
                      'structure',
                      { outlets: { 'structure-outlet': 'dashboards/director-view' } },
                    ]);
                    // .then(() => {
                    //   location.reload();
                    // });
                  }
                }
              });
          } else {
            // Switching to the subsidiary data ----start
            localStorage.setItem('isSubsidiary', 'false');
            // Switching to the subsidiary data ----end
            localStorage.setItem(
              'companyDetailsGoveva',
              safeJsonStringify(companyNameAndValue)
            );
            localStorage.setItem(
              'companyDetails',
              safeJsonStringify({
                companyName: companyNameAndValue.label,
                companyID: companyNameAndValue.value,
              })
            );
            localStorage.setItem('user', safeJsonStringify(data.user));
            localStorage.setItem('companyEVA', this.eva);
            sessionStorage.setItem('SessionName', 'userLoggedIn');
            localStorage.setItem('token', data.token);
            localStorage.setItem(
              'resources',
              safeJsonStringify(data.resources)
            );

            localStorage.setItem('rocketBaseURL', this.chatEngineURL);

            this.showTopBar();

            this.returnUrl =
              this.route.snapshot.queryParams['returnUrl'] || '/';
            if (this.returnUrl != '/') {
              try {
                var check64 = btoa(atob(this.returnUrl)) == this.returnUrl;
              } catch (err) {
                var check64 = false;
              }
              if (check64 == true) {
                this.returnUrl = atob(this.returnUrl);
              } else {
                this.returnUrl = this.returnUrl;
              }
              if (_.includes(this.returnUrl, 'http')) {
                window.open(this.returnUrl, '_self');
              } else {
                const urlAfterSplit = this.returnUrl.split(':');
                const lastElement = urlAfterSplit[urlAfterSplit.length - 1];
                const redirectUrl = _.first(lastElement.split(')'));
                this.router.navigate([
                  'structure',
                  { outlets: { 'structure-outlet': redirectUrl } },
                ]);
                // .then(() => {
                //   location.reload();
                // });
              }
            } else {
              this.router.navigate([
                'structure',
                { outlets: { 'structure-outlet': 'dashboards/director-view' } },
              ]);
              // .then(() => {
              //   location.reload();
              // });
            }
          }
        } else {
          $('#alertTitle').css('color', '#f00');
          const alertTitleText = $('#alertTitleText');
          if (alertTitleText.length) {
            alertTitleText.text('Failure!');
          } else {
            $('#alertTitle').text('Failure!');
          }
          $('#alertMessage').css('color', '#f00');
          $('#alertMessage').text(
            'Your last session was terminated incorrectly or is currently active, do you want to kill last session?'
          );
          // Show modal with backdrop enabled for click dismissal
          $('#messagePopUp').modal({
            backdrop: true,
            keyboard: true,
            show: true
          });
          this.setupModalCloseButton();
          this.messagePopUpTimeoutToogle();
        }
      },
      (exception) => {
        console.log('exception', exception);
      }
    );
  }

  forgotPassword() {
    this.router.navigate(['/requestPassword']);
  }

  messagePopUpTimeoutToogle() {
    const self = this;
    // Clear any existing timeout
    if (this.messagePopUpTimeout) {
      clearTimeout(this.messagePopUpTimeout);
      this.messagePopUpTimeout = null;
    }
    
    // Listen for Bootstrap modal hidden event to clear timeout when dismissed
    $('#messagePopUp').off('hidden.bs.modal.clearTimeout').on('hidden.bs.modal.clearTimeout', function() {
      if (self.messagePopUpTimeout) {
        clearTimeout(self.messagePopUpTimeout);
        self.messagePopUpTimeout = null;
      }
      // Clean up backdrop and body classes
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
    });
    
    // Also listen for backdrop clicks to dismiss immediately
    // Use a small delay to ensure backdrop is created
    setTimeout(function() {
      $(document).off('click.modalBackdrop').on('click.modalBackdrop', '.modal-backdrop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (self.messagePopUpTimeout) {
          clearTimeout(self.messagePopUpTimeout);
          self.messagePopUpTimeout = null;
        }
        $('#messagePopUp').modal('hide');
        $(document).off('click.modalBackdrop');
      });
      
      // Also allow clicking on the modal element itself (outside dialog) to dismiss
      $('#messagePopUp').off('click.modalDismiss').on('click.modalDismiss', function(e) {
        // Only dismiss if clicking directly on the modal element (not on dialog content)
        if ($(e.target).is('#messagePopUp')) {
          if (self.messagePopUpTimeout) {
            clearTimeout(self.messagePopUpTimeout);
            self.messagePopUpTimeout = null;
          }
          $('#messagePopUp').modal('hide');
          $(document).off('click.modalBackdrop');
          $('#messagePopUp').off('click.modalDismiss');
        }
      });
    }, 100);
    
    // Auto-dismiss after 5 seconds
    this.messagePopUpTimeout = setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass && popUpClass.includes('show')) {
        $('#messagePopUp').modal('hide');
        // Clean up backdrop
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        self.messagePopUpTimeout = null;
      }
    }, 5000);
  }

  hideTopBar() {
    $('.cat__top-bar').hide();
    $('.cat__menu-left').hide(); //hide the sidebar
    $('.cat__top-bar__right').hide(); //hide the logout icon
    $('.cat__footer').hide();
  }

  showTopBar() {
    $('.cat__menu-left').show();
    $('.cat__top-bar__right').show();
    $('.cat__top-bar').show();
    $('.cat__footer').show();
  }

  companySelection(companyId) {
    this.companyService.getcompanyDetailsNonValidateURL(companyId).subscribe(
      (companyData) => {
        // @ts-ignore
        if (_.size(companyData) > 0) {
          // @ts-ignore
          if (
            !_.isUndefined(companyData.companyData) &&
            _.size(companyData.companyData) > 0
          ) {
            // @ts-ignore
            this.isADCompany =
              companyData.companyData.IsADSubscribedFlag || false;
          }
        }

        if (this.isADCompany) {
          this.loginForm.controls.userName.clearValidators();
          this.loginForm.controls.userName.setValidators([Validators.required]);
          this.loginForm.controls.userName.updateValueAndValidity();
        } else {
          this.loginForm.controls.userName.clearValidators();
          this.loginForm.controls.userName.setValidators([
            Validators.required,
            Validators.email,
          ]);
          this.loginForm.controls.userName.updateValueAndValidity();
        }
      },
      (error) => {
        // console.log("runtimeError : " , error)
      }
    );

    try {
      this.companyService
        .getCompanyConfig(companyId)
        .subscribe((resData: any) => {
          // resData.configData = JSON.parse(
          //   this.commonFunction.decrypt(resData.configData)
          // );

          if (
            resData.configData &&
            this.loginForm.value.userName != 'superadmin@gmail.com'
          ) {
            this.companyConfig = {
              ...this.companyConfig,
              ...resData.configData,
              normalLogin: true,
            };
          } else {
            this.companyConfig = {
              authLogin: 'Inactive',
              twoFactor: 'Inactive',
              normalLogin: true,
            };
          }
        });
    } catch (error) {
      console.log('error', error);
    }
  }

  ngOnDestroy() {
    // Restore body scrolling when leaving login page
    $('body, html').removeClass('login-page-active');
    $('body, html').css({
      'overflow': '',
      'height': '',
      'max-height': '',
      'position': '',
      'width': ''
    });
  }
}
